export const REQUEST_LOGOUT = 'REQUEST_LOGOUT';
export const SET_USER = 'SET_USER';
export const LOGOUT = 'LOGOUT';
export const START_HOMEWORK = 'START_HOMEWORK';
export const START_REVISION = 'START_REVISION';
export const START_LESSON = 'START_LESSON';
export const SWITCH_LESSON_TASK = 'SWITCH_LESSON_TASK';
export const JOIN_CLASSROOM_SESSION = 'JOIN_CLASSROOM_SESSION';
export const SET_CURRENT_TASK = 'SET_CURRENT_TASK';
export const SET_LESSON_TASK_STATE = 'SET_LESSON_TASK_STATE';
export const USER_ACTIVE = 'USER_ACTIVE';
export const SPARXWEB_LOGOUT_FAILED_KEY = 'sparxwebLogoutFailed';

export function requestLogout() {
    return { type: REQUEST_LOGOUT };
}

export function setUser(user) {
    return { type: SET_USER, user };
}

export function logout() {
    return { type: LOGOUT };
}

export function startHomework() {
    return { type: START_HOMEWORK };
}

export function startRevision() {
    return { type: START_REVISION };
}

export function startLesson() {
    return { type: START_LESSON };
}

export function switchLessonTask() {
    return { type: SWITCH_LESSON_TASK };
}

export function joinClassroomSession(lessonCode, lessonDeliveryID = null) {
    return { type: JOIN_CLASSROOM_SESSION, lessonCode, lessonDeliveryID };
}

export function setCurrentTask(packageId, taskId, options = {}) {
    return { type: SET_CURRENT_TASK, packageId, taskId, options };
}

export function setCurrentGame(gameId, gameState) {
    return { type: SET_CURRENT_TASK, gameId, gameState };
}

export function setLessonTaskState(packageId, taskId, taskState) {
    return { type: SET_LESSON_TASK_STATE, packageId, taskId, taskState };
}

export function userActive(timestamp) {
    return { type: USER_ACTIVE, timestamp };
}
